jQuery(function($){

    

    $('.video video').on('click', toggleVideo);

    function toggleVideo(){
        let video = $(this)[0];
        var playButton = $(this).siblings('.video__play');
        
        var playIcon = playButton.data('play-src');
        var pauseIcon = playButton.data('pause-src');
        
        if (video.paused) {
            video.play();
            playButton.attr('src', pauseIcon);
            playButton.attr('alt', 'Pause button'); 
            $('.video').addClass('playing');
        } else {
            video.pause();
            playButton.attr('src', playIcon);
            playButton.attr('alt', 'Play button');
            $('.video').removeClass('playing');
        }
    }


});